import { configurableColumns, isDataColumn, cleanTotals, TOTAL_OPERATIONS } from './layouts'

export const fieldValue = (row, column) => typeof column.value === 'function' ? column.value(row) : row?.[column.key]
const nonempty = value => value != null && String(value).trim() !== ''
export function numericValue(value) {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value !== 'string' || !value.trim()) return null
  const text = value.trim().replace(/^R\$\s*/, '')
  if (/^-?\d+(\.\d+)?$/.test(text)) return Number(text)
  if (/^-?(\d+|\d{1,3}(\.\d{3})+)(,\d+)?$/.test(text)) return Number(text.replace(/\./g, '').replace(',', '.'))
  return null
}
export function totalFields(columns) { return configurableColumns(columns).filter(column => isDataColumn(column) && column.aggregate !== false) }
export function numericField(column, rows) {
  if (['date', 'text', 'identifier', 'boolean'].includes(column?.dataType)) return false
  return ['number', 'currency'].includes(column?.dataType) || (rows || []).some(row => numericValue(fieldValue(row, column)) !== null)
}
export function calculateTotals(columns, rows, rules) {
  const fields = new Map(totalFields(columns).map(column => [String(column.key), column]))
  return (cleanTotals(rules) || []).flatMap(rule => {
    const column = fields.get(rule.field)
    if (!column || (!['count', 'distinct'].includes(rule.operation) && !numericField(column, rows))) return []
    const values = (rows || []).map(row => fieldValue(row, column)).filter(nonempty), numbers = values.map(numericValue).filter(value => value !== null)
    let value = null
    if (rule.operation === 'count') value = values.length
    else if (rule.operation === 'distinct') value = new Set(values.map(item => typeof item + ':' + String(item))).size
    else if (rule.operation === 'sum') value = numbers.reduce((sum, n) => sum + n, 0)
    else if (numbers.length) {
      if (rule.operation === 'min') value = numbers.reduce((min, n) => Math.min(min, n))
      if (rule.operation === 'max') value = numbers.reduce((max, n) => Math.max(max, n))
      if (rule.operation === 'average') value = numbers.reduce((sum, n) => sum + n, 0) / numbers.length
    }
    let formatted = value == null ? '—' : value.toLocaleString('pt-BR', { maximumFractionDigits: 4 })
    if (value != null && !['count', 'distinct'].includes(rule.operation)) {
      try {
        if (typeof column.totalFormat === 'function') formatted = column.totalFormat(value, rows)
        else if (typeof column.format === 'function') formatted = column.format(value)
        else if (column.dataType === 'currency') formatted = value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      } catch { /* Formatação de célula que exige o registro não se aplica a um agregado. */ }
    }
    return [{ ...rule, id: rule.field + ':' + rule.operation, label: column.label + ' · ' + TOTAL_OPERATIONS[rule.operation], value, formatted }]
  })
}
